import styled from 'styled-components'

import { colors } from '../../../module/colors'
import { boxes } from '../../../module/boxes'
import { text_thinner } from '../../../module/style-variables'

export const AssessmentBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const AssessmentButton = styled.a`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${props => `${props.boxWidthPercent}%`};
`

const iconSize = '30px'

export const AssessmentIcon = styled.div`
  width: ${iconSize};
  height: ${iconSize};
  background-color: ${props => boxes[props.boxId].color};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const AssessmentDescription = styled.div`
  font-size: 11px;
  padding-top: 8px;
  padding-left: 6px;
  padding-right: 6px;
  color: ${colors.copy};
  font-weight: ${text_thinner};
`



// WEBPACK FOOTER //
// ./src/component/_presentational/AssessmentBar/AssessmentBar-styled.js